module.exports = __webpack_public_path__ + "img/logoenumawhite@2x.611efd62.png";